/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  modalContainer: {
    padding: '0.625rem 1.125rem',
    background: theme.palette.primary.backgroundColor2,
    maxWidth: '956px',
    width: '90%',
    borderRadius: '10px',
    outline: 'none',
    [theme.breakpoints.up('md')]: {
      marginLeft: '7%',
      marginBottom: '195px!important',
    },
    position: 'absolute',
    bottom: '3%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('md')]: {
      bottom: '3%',
      width: '91%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '93%',
      bottom: '13%',
    },
  },
  title: {
    color: theme.palette.primary.buttonColor,
  },
  titleBox: {
    paddingTop: 2,
  },
  summaryContainer: {
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    display: 'flex',
    color: theme.palette.primary.textColor3,
  },
  buttonContainer: {
    textDecoration: 'underline',
    textTransform: 'capitalize',
    color: theme.palette.primary.buttonColor,
    cursor: 'pointer',
  },
  toolTipContainer: {
    '& .MuiAlert-icon': {
      padding: '15px 0 7px 0',
    },
    '& .MuiAlert-action': {
      padding: '4px 0 0 0',
    },
    margin: '0 auto',
    pt: 2,

    [theme.breakpoints.between('sm', 'md')]: {
      pl: 4,
      pr: 4,
    },
  },

  infoContainer: {
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    borderRadius: '4px',
    '& .MuiAlert-icon': { color: theme.palette.primary.textColor3 },
    direction: 'row',
    justifyContent: 'space-between',
    margin: '0 auto',
  },
  solidctastyle: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    width: '11.5rem',
    padding: '0.3125rem',

    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    textTransform: 'none',
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 2px 4px -1px ${theme.palette.primary.boxShadow}, 0px 4px 5px  ${theme.palette.primary.boxShadow}, 0px 1px 10px  ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
  ctastyle: {
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    width: '9rem',
    padding: '0.3125rem',

    minHeight: '2.5rem',
    color: theme.palette.primary.buttonColor,
    textTransform: 'none',
    '&:hover': {
      background: theme.palette.primary.buttonColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: 0,
    },
  },
  confirmCTA: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    width: '12rem',
    padding: '0.3125rem',

    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 2px 4px -1px  ${theme.palette.primary.boxShadow}, 0px 4px 5px  ${theme.palette.primary.boxShadow}, 0px 1px 10px  ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
  confirmCTADisabled: {
    background: theme.palette.primary.buttonInactiveColor,
    width: '12rem',
    padding: '0.3125rem',
    pointerEvents: 'none',
    minHeight: '2.5rem',
    color: theme.palette.secondary.contrastText,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0.5rem',
    },
  },
});
export default styles;
